module.exports = __webpack_public_path__ + "img/ic_6.ca058da8.png";